import { Button, Modal, notification } from 'antd';
import { useEffect, useRef, useState } from 'react';

// PRODUCTION VALUES (uncomment when done testing):
// const ONE_DAY_MS = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
// const ONE_HOUR_MS = 60 * 60 * 1000; // 1 hour in milliseconds

// TEST VALUES (comment out when deploying to production):
const ONE_DAY_MS = 12 * 60 * 60 * 1000; // 12 hours for testing (toast)
const ONE_HOUR_MS = 30 * 60 * 1000; // 30 minutes for testing (modal)

export const usePageRefreshReminder = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [toastShown, setToastShown] = useState(false);
  const [modalDismissedTime, setModalDismissedTime] = useState<number | null>(null);
  const pageLoadTime = useRef(Date.now());

  useEffect(() => {
    // Set up intervals to check periodically
    const interval = setInterval(() => {
      const currentTime = Date.now();
      const timeSincePageLoad = currentTime - pageLoadTime.current;

      console.log('⏰ Refresh Reminder Check:', {
        timeSincePageLoad: Math.round(timeSincePageLoad / 1000) + 's',
        toastShown,
        modalVisible: isModalVisible
      });

      // Show toast after 24 hours if not shown yet
      if (timeSincePageLoad >= ONE_DAY_MS && !toastShown) {
        console.log('📢 Showing toast notification!');
        notification.warning({
          message: 'Sistem Güncellemesi',
          description: 'Sistemde güncelleme yapıldı lütfen sayfanızı yenileyin',
          duration: 0, // Don't auto-close
          key: 'refresh-reminder'
        });
        setToastShown(true);
      }

      // Show modal after 25 hours (1 hour after toast) or every hour if dismissed
      if (timeSincePageLoad >= ONE_DAY_MS + ONE_HOUR_MS) {
        if (modalDismissedTime === null) {
          // Modal never dismissed, show it
          console.log('🔔 Showing modal for the first time!');
          setIsModalVisible(true);
        } else {
          // Modal was dismissed, check if it's been an hour since dismissal
          const timeSinceDismissed = currentTime - modalDismissedTime;
          if (timeSinceDismissed >= ONE_HOUR_MS) {
            console.log('🔔 Showing modal again (1 hour since last dismissal)!');
            setIsModalVisible(true);
          }
        }
      }
    }, 60000); // Check every minute

    return () => clearInterval(interval);
  }, [toastShown, modalDismissedTime, isModalVisible]);

  const handleModalDismiss = () => {
    setIsModalVisible(false);
    setModalDismissedTime(Date.now());
  };

  const handlePageRefresh = () => {
    window.location.reload();
  };

  const refreshModal = (
    <Modal
      title="Sistem Güncellemesi"
      open={isModalVisible}
      onCancel={handleModalDismiss}
      footer={[
        <Button key="dismiss" onClick={handleModalDismiss}>
          Daha Sonra
        </Button>,
        <Button key="refresh" type="primary" onClick={handlePageRefresh}>
          Sayfayı Yenile
        </Button>
      ]}
      centered
      maskClosable={false}
    >
      <p>Lütfen en son güncellemeleri almak için sayfayı yenileyin.</p>
    </Modal>
  );

  return { refreshModal };
};
